import { Component } from '@angular/core'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    template: `<div appAutoSize style="border: 1px solid lightgray">
        <iframe
            width="100%"
            height="100%"
            src="/shiny/"
            frameborder="0"
            allowFullScreen="true"
        ></iframe>
    </div>`,
    standalone: true,
    imports: [AutoSizeDirective],
})
export class BidStatisticalAnalysisComponent {}
